import { createFileRoute } from '@tanstack/react-router';

import { Login } from '@@auth/Login';

// The login provider sends the user back here with the authorization code, which `Login` reads
export const Route = createFileRoute('/login')({
    component: Login,
});
